const souye = {
  state: {
    /*首页背景图片 只需要修改require里面的路径（图片存放于assets/img/home文件夹中）
    * */
    topLogo: require('../../assets/img/home/toplogo.jpg'), //首页公司logo
    homeTitle: {
      title1: '安徽金得电气设备有限公司', //标题1
      title2: 'JinDe Electrical Equipment', //标题2
      title3: '诚者，天之道也<br/>思诚者，人之道也', //标题3
    }, //首页1标题
    homeImg1: require('../../assets/img/home/home_top.jpg'), //首页背景图片1
    homeImg2: require('../../assets/img/home/home_do.jpg'), //首页背景图片2
    homeImg3: require('../../assets/img/home/home_anli.jpg'), //首页背景图片3
  },
};

export default souye